interface ViewBoxProps {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
}

export interface CounterpartyChartYAxisUnitLabelProps {
  value?: string;
  fill?: string;
  fontSize?: number;
  viewBox?: ViewBoxProps;
}

const Y_AXIS_TICK_MARGIN = 18;
const TOP_OFFSET = 10;

function CounterpartyChartYAxisUnitLabel({
  value,
  fill = 'var(--lumen-colors-gray-500)',
  fontSize = 12,
  viewBox,
}: CounterpartyChartYAxisUnitLabelProps) {
  if (!value || !viewBox) {
    return null;
  }

  const x = (viewBox.x ?? 0) + (viewBox.width ?? 0) - Y_AXIS_TICK_MARGIN;
  const y = (viewBox.y ?? 0) - TOP_OFFSET;

  return (
    <text x={x} y={y} fill={fill} fontSize={fontSize} textAnchor="end">
      {value}
    </text>
  );
}

export default CounterpartyChartYAxisUnitLabel;
